import * as bootstrap from "bootstrap"
window.bootstrap = bootstrap

// Tooltips und Popovers müssen nach jedem Turbo-Render neu initialisiert werden,
// weil Bootstrap sie nur einmalig an DOM-Elemente bindet.
const initializeBootstrapComponents = () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new bootstrap.Tooltip(el))
  document.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => new bootstrap.Popover(el))
}

;["turbo:load", "turbo:render", "turbo:frame-load"].forEach((event) => {
  document.addEventListener(event, initializeBootstrapComponents)
})
